import { render, staticRenderFns } from "./CreateCampaignModal.vue?vue&type=template&id=10d22270&scoped=true"
import script from "./CreateCampaignModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCampaignModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CreateCampaignModal.vue?vue&type=style&index=0&id=10d22270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d22270",
  null
  
)

export default component.exports